import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useLazyGetTokenListingQuery } from "../../services/users";
import { errorToast } from "../../helpers";
import Pagination from "../../components/Pagination";
import moment from "moment";
import { LISTING_TYPE, ROLE, TOKEN_CREDIT_TYPE } from "../../constants/enums";
import Loader from "../../helpers/constants/Loader";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TokenHistoryAgent = ({ type }: any) => {

  const [data, setData] = useState<any[]>([]);
  const [dataCredit, setDataCredit] = useState<any[]>([]);
  const [TokenListing, { isLoading }] = useLazyGetTokenListingQuery();
  const { _id } = useParams();
  const [value, setValue] = React.useState(0);
  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setData([]);
    setDataCredit([]);
  };
  const fetchApi = async () => {
    try {
      const response = await TokenListing({ userId: _id, detailType: value === 0 ? 5 : 14, page: page, limit: limit }).unwrap();
      value === 0 ? setData(response?.data?.historyDetails || []) : setDataCredit(response?.data?.rows || [])
      setTotalCount(response?.data?.count);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const generateText = (item: any) => {
    if (item?.tokenhistories?.isUpgrade) {
      return item?.tokenhistories?.listingType
        ? <p> Tokens are used for upgrading the property into <span style={{ fontWeight: "600" }} >{LISTING_TYPE[item?.tokenhistories?.listingType]}</span></p>
        : 'Tokens are used for upgrading the property';
    }
    else if (item?.tokenhistories?.boostProfileId) {
      return item?.tokenhistories?.boostprofile?.title
        ? <p>Tokens are used for boosting the property into <span style={{ fontWeight: "600" }}> {item?.tokenhistories?.boostprofile?.title}</span></p>
        : 'Tokens are used for boosting the property';
    }
    else if (item?.tokenhistories?.adsId?.title) {
      return <p>Tokens are used for adding the <span style={{ fontWeight: "600" }}>Banner</span></p>;
    } else {
      return "-"
    }
  };

  const generateTextForCredit = (item: any) => {
    if (item === TOKEN_CREDIT_TYPE.RECEIVED_TOKENS_BY_ADMIN) {
      return (
        <p>
          Tokens received from <span style={{ fontWeight: "600" }}>Admin</span>
        </p>
      );
    } else if (item === TOKEN_CREDIT_TYPE.RENEWED_TOKEN_EVERY_MONTH) {
      return (
        <p>
          Tokens received for monthly renewal

        </p>
      );
    } else {
      return "-";
    }
  };
  const calculateRemainingDays = (expiryDate: string) => {
    const now = moment(); // Current date and time
    const expiry = moment(expiryDate); // Expiry date
    const diffInDays = expiry.diff(now, "days"); // Difference in days

    return diffInDays >= 0 ? `${diffInDays} days ` : "Expired";
  };

  useEffect(() => {
    fetchApi();
  }, [_id, value, page, limit]);

  return (
    <>
      <Card className="cards">
        <Loader isLoad={isLoading} />
        <Box className="custom_tabs">
          <Box className="flx_sc">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Token history" {...a11yProps(0)} />
              <Tab label={type === "company" ? "Token Spent on agents" : "Token received from company "} {...a11yProps(1)} />

            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <TableContainer className="table_container" style={{ marginTop: 0 }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell>Remaining days</TableCell>
                    <TableCell>Property Name</TableCell>
                    <TableCell>Listing Type</TableCell>
                    <TableCell>Validity</TableCell>
                    <TableCell>Token</TableCell>
                    {type === "company" ? (
                      <>
                        <TableCell>Agent Name</TableCell>
                        <TableCell>Agent BRN</TableCell>
                        <TableCell>Action performed by</TableCell>
                      </>
                    ) : ("")}
                    <TableCell>Spends</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length === 0 || !data[0].tokenhistories ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        No token history available
                      </TableCell>
                    </TableRow>
                  ) : (
                    data?.map((item: any, index: number) => (
                      <TableRow key={item?.tokenhistories?._id}>
                        <TableCell align="center"> {(page - 1) * 10 + index + 1}</TableCell>
                        <TableCell align="center"> {item?.tokenhistories?.tokensCredited ? "Token Credited" : "Token Debited"}</TableCell>
                        <TableCell>
                          {item?.tokenhistories?.createdAt ? moment(item?.tokenhistories?.createdAt).format("LLL") : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.tokenhistories?.propertyExpiryDate ? moment(item?.tokenhistories?.propertyExpiryDate).format("LLL") : "-"}
                        </TableCell>
                        <TableCell>
                          {item?.tokenhistories?.propertyExpiryDate
                            ? calculateRemainingDays(item?.tokenhistories?.propertyExpiryDate)
                            : "-"}
                        </TableCell>
                        <TableCell>{item?.tokenhistories?.propertyId?.name ? item?.tokenhistories?.propertyId?.name + " (" + item?.tokenhistories?.propertyId?.referenceId + ")" : "-"}</TableCell>

                        <TableCell>{item?.tokenhistories?.listingType ? LISTING_TYPE[item?.tokenhistories?.listingType] : "-"}</TableCell>
                        <TableCell>{item?.tokenhistories?.validity ? item?.tokenhistories?.validity : "-"}</TableCell>
                        <TableCell>{item?.tokenhistories?.token || "0"}</TableCell>
                        {type === "company" ? (
                          <>
                            <TableCell>{item?.tokenhistories?.agentId?.name ? item?.tokenhistories?.agentId?.name + " (" + item?.tokenhistories?.agentId?.referenceId + ")" : "-"}</TableCell>
                            <TableCell>{item?.tokenhistories?.agentId?.BRN || "-"}</TableCell>
                            <TableCell>{item?.role===ROLE.AGENT? "AGENT": item?.role===ROLE.AGENCY?"COMPANY":"-"}</TableCell>
                          </>
                        ) : ("")}
                        <TableCell>{item?.tokenhistories?.tokensCredited ? generateTextForCredit(item?.tokenhistories?.tokensCredited) : item ? generateText(item) : "-"}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <TableContainer className="table_container" style={{ marginTop: 0 }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">S.No</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Token</TableCell>
                    <TableCell>Agent Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!dataCredit.length ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        No token history available
                      </TableCell>
                    </TableRow>
                  ) : (
                    dataCredit?.map((item: any, index: number) => (
                      <TableRow key={item?.tokenhistories?._id}>
                        <TableCell align="center"> {(page - 1) * 10 + index + 1}</TableCell>
                        <TableCell>
                          {item?.transactionHistory?.createdAt ? moment(item?.transactionHistory?.createdAt).format("LLL") : "-"}
                        </TableCell>


                        <TableCell>{item?.transactionHistory?.token || "0"}</TableCell>

                        <TableCell>{item?.userId?.name ? item?.userId?.name + " (" + item?.userId?.referenceId + ")" : "-"}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </Box>

      </Card>
      {data?.length > 0 ? (
        <Pagination
          limit={limit}
          setLimit={setLimit}
          setPage={setPage}
          module={value === 0 ? data : dataCredit}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default TokenHistoryAgent;
